import clsx from 'clsx';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import React, { useState } from 'react';
import styles from './Radio.module.scss';

type RadioProps = {
    error?: string;
    label?: string;
    inlineLabel?: string;
    description?: string;
    checked?: boolean;
    className?: string;
    onChange?: (checked: boolean) => void;
};

export const Radio: React.FC<RadioProps> = ({
    error,
    label,
    inlineLabel,
    description,
    checked: checkedProp,
    className,
    onChange
}) => {
    const [checked, setChecked] = useState(checkedProp ?? false);

    React.useEffect(() => {
        if (checkedProp !== checked) {
            setChecked(checkedProp ?? false);
        }
    }, [checkedProp]);

    const handleClick = () => {
        // In a RadioGroup, the radio should not toggle itself
        // It should only notify that it was clicked
        if (checkedProp !== undefined) {
            // Controlled externally (used in RadioGroup)
            onChange?.(true);
        } else {
            // Independent functionality (toggle)
            const newChecked = !checked;
            setChecked(newChecked);
            onChange?.(newChecked);
        }
    };

    return (
        <div className={clsx(styles.root, className)}>
            {label && <Label error={error}>{label}</Label>}

            <div className={styles.container}>
                <div
                    className={styles.inlineContainer}
                    onClick={handleClick}
                >
                    <div className={clsx(styles.radioIcon, { [styles.checked]: checked })}>
                        <span />
                    </div>

                    {inlineLabel && <span className={styles.inlineLabel}>{inlineLabel}</span>}
                </div>

                {description && <span className={styles.optionDescription}>{description}</span>}
            </div>
        </div>
    );
};
